module.exports = __webpack_public_path__ + "img/coin-logo.32997217.png";